import {Inject, Injectable} from '@angular/core';
import {MessageService} from '../core/service/message.service';
import {UserService} from '../core/service/user.service';
import {ConfigService} from './config.service';
import {UserRoles} from '../../assets/config/shared/user-role.settings';


/**
 * @copyright UMWELT-GIS: Schweizerische Bundesbahnen SBB, 2018
 * @class ConfigUtilsService
 * @version 0.0.1
 * @since August 2018
 * @description The ConfigUtilsService provides the helper functionality for the configs
 */
@Injectable({
  providedIn: 'root'
})
export class ConfigUtilsService {

  constructor(@Inject(MessageService) private _messageService: MessageService,
              @Inject(UserService) public _userService: UserService,
              @Inject(ConfigService) public _configService: ConfigService) {
  }

  /**
   * @function validateLayerSwitchForViewer
   * @description check if user is viewer and switch services than
   */
  public validateLayerSwitchForViewer() {

    // ========= check each configs which needs to be switched =======
    this.updateLayerListConfigForViewerUser();
  }

  /**
   * @function updateLayerListConfigForViewerUser
   * @description check layerlist config, if user is viewer and switch services than
   */
  private updateLayerListConfigForViewerUser() {
    this._configService.layerListConfig.layerList.forEach(lyrConfig => {
      if (lyrConfig.checkViewer) {
        this.setLayerViewerPostFix(lyrConfig);
      } else if (lyrConfig.isGroupLayer) {
        lyrConfig.layers.forEach(lyr => {
          if (lyr.checkViewer) this.setLayerViewerPostFix(lyr);
        });
      }
    });
  }

  /**
   * @description set Layer VIEWER_POSTFIX if user is not editor
   */
  private setLayerViewerPostFix(lyrConfig) {
    const isEditor = this.userIsEditor(lyrConfig.fkLayer, lyrConfig.role);
    if (!isEditor) {
      lyrConfig.fkLayer = lyrConfig.fkLayer + UserRoles.VIEWER_POSTFIX;
    }
  }

  /**
   * @function userIsEditor
   * @param fkLayer
   * @param role
   * @return boolean, if user is editor return true esle false
   * @description check if user has editor role or viewer role
   */
  private userIsEditor(fkLayer: string, role?: string): boolean {
    const userRole = role ? role : fkLayer;
    const env = this._configService.getRolesEnvironment();
    const editorRole = `${UserRoles.IMMO_PREFIX}${UserRoles.EDITOR_POSTFIX}_${env}`;
    const filteredRoleEditor = this._userService.user.roles.filter(f => f === editorRole);
    return filteredRoleEditor.length > 0;
  }
}
